<script lang="ts" setup>
import { inject, watch } from 'vue';

import type { Ref } from 'vue';
import type { IManifest } from '@/types/IManifest';

const manifest = inject('manifest') as Ref<IManifest>;
const size = inject('skyBoxSize') as Ref<number>;

const sizeWatcher = (newValue: number) => {
  if (!manifest.value.skybox) return;
  manifest.value.skybox.skyboxSize = newValue;
};

const manifestWatcher = (newValue: IManifest) => {
  if (!newValue.skybox) return;
  size.value = newValue.skybox.skyboxSize;
};

watch(size, sizeWatcher);
watch(manifest, manifestWatcher);
</script>

<template>
  <div class="flex flex-row mb-1 items-center">
    <label for="skybox-size" class="text-xs mr-2">Size</label>
    <input
      id="skybox-size"
      v-model="size"
      type="number"
      step="1"
      min="40"
      max="200"
      class="border p-1 text-xs flex-grow"
    >
  </div>
</template>
